/** Integer amount in öre. 1 SEK = 100 öre. Never use floats for money. */
export type Ore = number;

export function ore(sek: number, oreFraction = 0): Ore {
  if (!Number.isInteger(sek) || !Number.isInteger(oreFraction)) {
    throw new Error('ore() takes integer SEK and integer öre parts');
  }
  return sek * 100 + oreFraction;
}

/** Parse Swedish-style user input like "1 234,50" or "1234.5" into öre. */
export function parseSek(input: string): Ore | null {
  const cleaned = input.replace(/\s/g, '').replace(',', '.');
  if (!/^-?\d+(\.\d{0,2})?$/.test(cleaned)) return null;
  const negative = cleaned.startsWith('-');
  const [whole = '0', frac = ''] = cleaned.replace('-', '').split('.');
  const value = Number(whole) * 100 + Number(frac.padEnd(2, '0'));
  return negative ? -value : value;
}

const sekFormatter = new Intl.NumberFormat('sv-SE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format öre as "1 234,50". Add " kr" in the UI where appropriate. */
export function formatSek(amount: Ore): string {
  return sekFormatter.format(amount / 100);
}

export function sum(values: Iterable<Ore>): Ore {
  let total = 0;
  for (const v of values) total += v;
  return total;
}
